var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V9.75C19 7.75 20.5 6 22.5 5.5C27.5 4.75 32.5 4.75 37.5 5.5C39.5 5.75 41 7.5 41 9.75V24.5C41 27.5 38.5 30 35.5 30H24.5C21.5 30 19 32.5 19 35.5V50.25C19 52.25 20.5 54 22.5 54.5C27.5 55.25 32.5 55.25 37.5 54.5C39.5 54.25 41 52.5 41 50.25V41",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19H50.25C52.25 19 54 20.5 54.5 22.5C55.25 27.5 55.25 32.5 54.5 37.5C54.25 39.5 52.5 41 50.25 41H30",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19H9.75C7.75 19 6 20.5 5.5 22.5C4.75 27.5 4.75 32.5 5.5 37.5C5.75 39.5 7.5 41 9.75 41H19",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.125V12.125",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47.875V47.875",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.3b65a901f6d87fb42740fffb838c688b.svg";
export { ForwardRef as ReactComponent };